import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/applications')({
  component: RouteComponent,
  staticData: {
    icon: 'KeyRound',
    title: 'Applications',
  },
});

function RouteComponent() {
  return <Outlet />;
}
